/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeData } from '../models/EmployeeData';
import type { EmployeeDataExportTableConfig } from '../models/EmployeeDataExportTableConfig';
import type { EmployeeDataFile } from '../models/EmployeeDataFile';
import type { EmployeeDataSearchFields } from '../models/EmployeeDataSearchFields';
import type { EmployeeDataSort } from '../models/EmployeeDataSort';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeeService {

    /**
     * Get Employee Data
     * @returns any Success
     * @throws ApiError
     */
    public static getEmployees({
        plan,
        fileId,
        jobCode,
        compositeId,
        search,
        department,
        searchFields,
        businessUnit,
        jobSubFamily,
        workLocation,
        limit,
        offset,
        sort,
    }: {
        /**
         * plan
         */
        plan?: number,
        /**
         * fileId
         */
        fileId?: number,
        /**
         * jobCode
         */
        jobCode?: string,
        /**
         * compositeId
         */
        compositeId?: number,
        /**
         * search
         */
        search?: string,
        department?: Array<string>,
        searchFields?: Array<EmployeeDataSearchFields>,
        businessUnit?: Array<string>,
        jobSubFamily?: Array<number>,
        workLocation?: Array<string>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        sort?: EmployeeDataSort,
    }): CancelablePromise<{
        rows?: Array<EmployeeData>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee',
            query: {
                'plan': plan,
                'fileId': fileId,
                'jobCode': jobCode,
                'compositeId': compositeId,
                'search': search,
                'department': department,
                'searchFields': searchFields,
                'businessUnit': businessUnit,
                'jobSubFamily': jobSubFamily,
                'workLocation': workLocation,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export Employee data
     * @returns any Success
     * @throws ApiError
     */
    public static exportEmployeeData({
        requestBody,
    }: {
        requestBody: {
            /**
             * Filter by Plan
             */
            plan?: number;
            /**
             * Filter by Employee File
             */
            fileId?: number;
            /**
             * Filter by department
             */
            department?: Array<string>;
            /**
             * Filter by Business Unit
             */
            businessUnit?: Array<string>;
            /**
             * Filter by Job sub Family
             */
            jobSubFamily?: Array<number>;
            /**
             * Filter by Work Location
             */
            workLocation?: Array<string>;
            /**
             * Filter search
             */
            search?: string;
            /**
             * Table config
             */
            config?: Array<EmployeeDataExportTableConfig>;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employee/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Employee Data File List
     * @returns EmployeeDataFile Success
     * @throws ApiError
     */
    public static getEmployeeDataFiles(): CancelablePromise<Array<EmployeeDataFile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/file',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct business units
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryBusinessUnit({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/businessUnit',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct cities
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryCity({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/city',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct countries
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryCountry({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/country',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct custom fields
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryCustomField({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/customField',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct departments
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryDepartment({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/department',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct states
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryRegion({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/region',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct states
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryState({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/state',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of distinct work locations
     * @returns string Success
     * @throws ApiError
     */
    public static getEmployeeDataDictionaryWorkLocation({
        plan,
    }: {
        /**
         * planId
         */
        plan?: number,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/dictionary/workLocation',
            query: {
                'plan': plan,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
